module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-line1-f0f8f199fc9c0c7cad325c3d5e9ad448.svg";